{
  "groups": {
    "boundariesSlots": "Límites / Posiciones",
    "controls": "Controles",
    "general": "General",
    "monitoring": "Monitoreo",
    "speedFlow": "Velocidad / Caudal"
  },
  "linkedDevice": {
    "deviceAlias": "Alias del dispositivo"
  },
  "stopDetection": {
    "description": "Te envía un mensaje de texto cuando se detecta que este pivote aplica agua sin moverse, permaneciendo dentro del radio de distancia mínima durante toda la ventana de tiempo.",
    "label": "Detección de parada (GPS)",
    "minimumDistance": "Distancia mínima",
    "timeWindow": "Ventana de tiempo",
    "wheelDescription": "Te envía un mensaje de texto cuando el sensor de rueda del monitor vinculado detecta que este pivote ha dejado de moverse.",
    "wheelLabel": "Detección de parada (rueda)",
    "wheelUpdateFailed": "No se pudo actualizar la notificación de parada de rueda. Inténtalo de nuevo."
  }
}
